import { combineReducers } from '@reduxjs/toolkit';
import log from './logSlice';


const logReducer = combineReducers({
    log,
});

export default logReducer;
